// ---------------------------------------------------------------------------
// Renderer — Public API
// ---------------------------------------------------------------------------
// Side-effect imports register each component renderer in the registry.
// The renderToHtml function is the main entry point.

import { attr } from "./escape.js";
import { registerRenderer } from "./registry.js";

// Component registrations (side-effect imports)
import "./components/hero-section.js";
import "./components/lead-form.js";
import "./components/multi-step-form.js";
import "./components/text-block.js";
import "./components/cta-banner.js";
import "./components/testimonial-grid.js";
import "./components/reviews-grid.js";
import "./components/pricing-table.js";
import "./components/video-embed.js";
import "./components/countdown-timer.js";
import "./components/calendar-embed.js";
import "./components/faq-accordion.js";
import "./components/image-gallery.js";
import "./components/social-proof.js";
import "./components/navigation-bar.js";
import "./components/popup-trigger.js";
import "./components/tracking-pixel.js";
import "./components/order-bump.js";
import "./components/stats-counter.js";
import "./components/booking-widget.js";
import "./components/blog-post-card.js";
import "./components/blog-listing-grid.js";
import "./components/feature-grid.js";
import "./components/logo-cloud.js";
import "./components/comparison-table.js";
import "./components/roi-calculator.js";
import "./components/social-proof-popup.js";
import "./components/before-after.js";
import "./components/embed-widget.js";
import "./components/chat-widget.js";
import "./components/video-player.js";
import "./components/progress-bar.js";
import "./components/quiz-block.js";
import "./components/exercise-block.js";
import "./components/drip-gate.js";
import "./components/heading.js";
import "./components/text.js";
import "./components/image.js";
import "./components/button.js";
import "./components/divider.js";
import "./components/spacer.js";
import "./components/blockquote.js";
import "./components/alert.js";
import "./components/newsletter.js";
import "./components/container.js";
import "./components/columns.js";
import "./components/section-block.js";
import "./components/hero.js";
import "./components/feature-card.js";
import "./components/icon-text.js";
import "./components/client-logos.js";
import "./components/awards.js";
import "./components/timeline.js";
import "./components/code-block.js";
import "./components/data-table.js";
import "./components/tabs.js";
import "./components/social-icons.js";
import "./components/map-embed.js";
import "./components/video-background.js";
import "./components/image-hotspot.js";
import "./components/carousel.js";
import "./components/notification-bar.js";
import "./components/offer-card.js";
import "./components/gift-card.js";
import "./components/coupon.js";
import "./components/breadcrumb.js";
import "./components/back-to-top.js";
import "./components/floating-cta.js";
import "./components/language-switcher.js";
import "./components/sticky-section.js";
import "./components/scroll-triggered-cta.js";
import "./components/social-feed.js";
import "./components/button-group.js";
import "./components/services-list.js";
import "./components/contact-info.js";
import "./components/opening-hours.js";
import "./components/team-grid.js";
import "./components/rich-text.js";
import "./components/accordion.js";
import "./components/footer-block.js";
import "./components/contact-form.js";
import "./components/case-study.js";
import "./components/appointment-form.js";
import "./components/waitlist-form.js";
import "./components/membership-plans.js";
import "./components/survey.js";
import "./components/call-booking.js";

registerRenderer("lottie-player", {
  render(props) {
    const source = typeof props.source === "string" ? props.source.trim() : "";
    if (!source) {
      return "<!-- lottie-player missing source -->";
    }

    const autoplay = props.autoplay === "no" ? "no" : "yes";
    const loop = props.loop === "no" ? "no" : "yes";
    const speed = typeof props.speed === "number" ? props.speed : Number(props.speed ?? 1);
    const trigger = typeof props.trigger === "string" ? props.trigger : "none";
    const width = typeof props.width === "string" && props.width.trim() ? props.width : "100%";
    const height = typeof props.height === "string" && props.height.trim() ? props.height : "auto";
    const style = [
      `width:${width}`,
      height === "auto" ? "min-height:240px" : `height:${height}`,
    ].join(";");

    return `<section class="ease-section ease-lottie-player"><div class="ease-lottie-player__frame" data-ease-lottie data-lottie-source="${attr(source)}" data-lottie-autoplay="${attr(autoplay)}" data-lottie-loop="${attr(loop)}" data-lottie-speed="${attr(String(speed))}" data-lottie-trigger="${attr(trigger)}" style="${attr(style)}"></div></section>`;
  },
});

// Public exports
export { renderToHtml } from "./document.js";
export { getRenderer, getRegisteredTypes } from "./registry.js";
export type {
  RenderInput,
  SiteRenderContext,
  RenderContext,
  RenderedPage,
  ComponentRenderer,
  PuckData,
  PuckComponent,
} from "./types.js";
